export default {
  confirmOrder: 'Potwierdź zamówienie',
  createSuccess: 'Zamówienie utworzone pomyślnie',
  orderPrice: 'Całkowita cena zamówienia',
  otherAction: 'Inne działania',
  orderStatus: 'Status zamówienia',
  afterSales: 'Obsługa posprzedażowa',
  allSelect: 'Zaznacz wszystko',
  orderNo: 'Nr zamówienia',
  createTime: 'Data utworzenia',
  productRemark: 'Informacje o uwagach do produktu',
  productRemarkHolder:
    'Wiadomość dla agenta zakupowego, jeśli nie ma specjalnych wymagań zakupowych, nie wypełniaj.',
  orderDetail: 'Szczegóły zamówienia',
  goPay: 'Przejdź do płatności',
  cancelpay: 'Anuluj Płatność',
  cancelPay: 'Anulować płatność?',
  cancelOrder: 'Anulować zamówienie?',
  cancelorder: 'Anuluj zamówienie',
  cancelOrderProduct: 'Anulować produkt?',
  cancelorderProduct: 'Anuluj produkt',
  cancelPayResultHint:
    'Po anulowaniu płatności nie można jej przywrócić, proszę wybrać powód anulowania płatności',
  cancelOrderResultHint:
    'Po anulowaniu zamówienia nie można go przywrócić, proszę podać powód anulowania zamówienia',
  delOrder: 'Usuń zamówienie',
  delOrderHint:
    'Czy na pewno chcesz usunąć zamówienie? Jeśli produkt został zwrócony, przedmiot nie zostanie zwrócony sprzedawcy w celu zwrotu pieniędzy',
  cancelSuccess: 'Anulowanie udane',
  delSuccess: 'Usunięto pomyślnie',
  orderBin: 'Kosz',
  backOrder: 'Powrót do Moich zamówień',
  restoreOrder: 'Przywróć zamówienie',
  remark: 'Uwagi',
  all: 'Wszystkie',
  productName: 'Nazwa produktu',
  submitTime: 'Czas złożenia',
  orderConsult: 'Zapytanie o zamówienie',
  appendService: 'Usługa dodatkowa',
  iKnow: 'Rozumiem',
  cancelReturnBag: 'Anuluj zwrot i wymianę',
  isCancelApply: 'Czy na pewno chcesz anulować wniosek?',
  cancelBackTax: 'Anuluj dopłatę',
  productAttr: 'Atrybuty produktu',
  backTaxType: 'Typ dopłaty',
  taxPrice: 'Kwota dopłaty',
  productBackTax: 'Dopłata za produkt',
  freightBackTax: 'Dopłata za przesyłkę',
  productTaxPrice: 'Kwota dopłaty za produkt',
  freightTaxPrice: 'Kwota dopłaty za przesyłkę',
  totalTaxPrice: 'Całkowita kwota dopłaty',
  productStatus: 'Status produktu',
  isNeedTax: 'Wymaga dopłaty',
  yes: 'Tak',
  no: 'Nie',
  iThinkAbout: 'Przemyślę to',
  revokeCheckedProduct: 'Zwróć zaznaczony produkt',
  taxTips1:
    'Prosimy o [Dopłatę] lub [Anulowanie] jak najszybciej, aby nie wpływało to na zakup innych produktów w zamówieniu.',
  cancelTaxTips1:
    'Jeśli nie chcesz dokonać dopłaty, nie będziemy mogli zakupić produktu wymagającego dopłaty.',
  cancelTaxTips2:
    'Zaznaczone produkty zostaną anulowane po zwrocie, a koszt produktu zostanie zwrócony na Twoje konto.',
  cancelTaxTips3:
    'Niezaznaczone produkty będą nadal przechowywane i będziemy kontynuować zakup dla Ciebie.',
  cancelReason: {
    0: 'Nie chcę tego kupować',
    1: 'Błędnie wprowadzone informacje',
    2: 'Brak towaru u sprzedawcy',
    3: 'Nie mogę zapłacić',
    4: 'Inne powody',
    5: 'ryzyko marki',
  },
  hint: 'Wskazówka',
  orderStatusEnum: {
    0: 'Oczekuje na płatność',
    1: 'Nieprzetworzone',
    2: 'W trakcie weryfikacji',
    3: 'Zamówienie przekazane',
    4: 'Zamówienie anulowane',
    5: 'Dopłata za przesyłkę',
    6: 'Ryzykowny produkt',
    7: 'Zamówienie zwrócone',
    8: 'Płatność w toku',
    9: 'Zakończone',
  },
  returnGood: {
    name: 'Zwrot/Wymiana',
    selectType: 'Wybierz typ',
    returnGood: 'Zwrot',
    returnDayTips: 'Zazwyczaj trwa 7-15 dni',
    changeGood: 'Wymiana',
    changeDayTips: 'Zazwyczaj trwa 7-20 dni',
    returnReasonEnum: {
      0: 'Kupiono błędnie/Nie podoba się',
      1: 'Sprzedawca wysłał zły produkt?',
      2: 'Problem z jakością produktu',
      3: 'Nie wysłano w uzgodnionym terminie',
      5: 'Inne powody',
    },
    returnReasonSelect: 'Wybierz powód zwrotu',
    returnExplain: 'Instrukcje zwrotu',
    residueReturnNumTips: 'Pozostałe darmowe zwroty w tym miesiącu',
    returnTips:
      'Ostateczna weryfikacja zwrotu z powodu sprzedawcy lub platformy, acbuy zwróci poniesione przez Ciebie koszty wysyłki.',
    changeTips:
      'W przypadku zwrotów lub wymian z powodu sprzedawcy, możesz nadal musieć ponieść część kosztów wysyłki wymiany.',
    returnTip4: 'Przyjazne przypomnienie',
    returnTip5:
      'Usługa zwrotu i wymiany będzie miała określoną liczbę darmowych operacji. (Każdy użytkownik może ubiegać się o zwrot lub wymianę towaru bez opłaty serwisowej za pierwszym razem w każdym miesiącu, podczas gdy opłata za wysyłkę generowana przez zwrot lub wymianę towaru jest negocjowana między agentem a sprzedawcą i pobierana przez acbuy.) Opłata serwisowa za zwrot i wymianę acbuy: 5 CNY/zamówienie',
    returnTip10:
      'Jeśli zwrot lub wymiana wynika z odpowiedzialności agenta zakupowego, sprzedawcy lub platformy, system zwróci tę opłatę operacyjną w wysokości 5 juanów na Twoje konto salda acbuy.',
  },
  holder: {
    selectCancelReason: 'Wybierz powód zwrotu',
    inputOtherReason: 'Wprowadź powód',
    inputSearchHint: 'Nazwa/Nr zamówienia/Nr produktu',
    inputCancelReason: 'Wprowadź powód anulowania zamówienia',
  },
  selectProducts: 'Wybierz produkty',
  confirmStepOrder: 'Potwierdź zamówienie',
  PayForProducts: 'Zapłać za produkty',
  sendingPackages: 'Wysyłanie paczek',
  submitDelivery: 'Złóż do wysyłki',
  readAgreeText: 'Przeczytałem i zgadzam się',
  disclaimer: 'Zastrzeżenia',
  orderNote:
    'Uwaga: Po zakończeniu płatności będziesz musiał złożyć paczkę do wysyłki międzynarodowej, gdy zamówienie dotrze i zostanie zmagazynowane w magazynie.',
  goPay2: 'Dodatkowa płatność',
  backTax: 'Dopłata',
  reminder: 'Przypomnienie',
  disclaimer1: 'Opis przedmiotów zabronionych',
  disclaimer2: 'Warunki świadczenia usług',
  disclaimer3: 'Polityka zwrotów',
  customPhotosTips:
    'Zdjęcie dostarcza tylko jednego wymagania szczegółowego do sfotografowania przedmiotu',
  backCartEdit: 'Powrót do edycji koszyka',
  customPhotosReminderLabel: 'Uprzejme przypomnienie',
  customPhotosReminder: 'Zdjęcie dostarcza tylko jedno wymaganie jednego produktu',
  packageAgreeTip1:
    '1. Opóźnienia, uszkodzenia, straty, podatki, konfiskata i inne niepewności związane z usługami dostawcy logistycznego są poza naszą kontrolą i nie ponosimy odpowiedzialności za wynikające z tego zobowiązania. Jednak dołożymy wszelkich starań, aby przypomnieć Ci o przemyśleniu zakupu, pomóc w rozwiązaniu problemów z dostawcą logistycznym i zrekompensować zgodnie z polityką posprzedażową dostarczoną przez dostawcę logistycznego.',
  packageAgreeTip2:
    '2. Zalecamy dokładne zadeklarowanie paczki. Jeśli Twoja paczka przejdzie losową kontrolę podczas odprawy celnej w kraju docelowym, możesz być zmuszony do zapłacenia podatków. Jeśli otrzymasz zawiadomienie o podatku, prosimy o jego opłacenie, w przeciwnym razie możesz ponieść konsekwencje, takie jak wysokie opłaty za zwrot i zniszczenie paczki.',
  applyRefund: 'Złóż wniosek o zwrot',
  refundReminder:
    'Wskazówka: Po złożeniu wniosku o zwrot kupujący zweryfikuje status produktu i nie można anulować wniosku o zwrot przed weryfikacją.',
  inputApplyReason: 'Wprowadź powód wniosku',
  orderConfirm: 'Potwierdź zamówienie',
  replyMsg: 'Odpowiedź na wiadomość',
  replyMsgTips: 'Informacja, którą wysyłasz, powiadomimy kupującego o weryfikacji.',
  shoppingOrder: 'Zamówienia',
  transportOrder: 'Zlecenia spedycyjne',
  choosePlatform: 'Wybierz platformę',
  selectTargetCountry: 'Wybierz kraj docelowy',
  selectCountryTips:
    'Wybierz/wypełnij swój kraj docelowy, aby acbuy mógł odróżnić, czy przedmiot może zostać dostarczony, czy nie.',
  pleaseSelectOrder: 'Proszę wybrać zlecenia w tej samej walucie do rozliczenia',
  canNotStorageTip:
    'Towar został przyjęty do magazynu ponad 5 dni temu i nie można ubiegać się o zwrot lub wymianę.',
  purchaseService: 'Usługi zakupu',
  refundProgress: 'Przetwarzanie refundacji w toku',
  returnChangeTip:
    'Uwaga: Jeśli produkt ma drobne wady jakościowe (ślady kleju, skazy, plamy), sprzedawca może nie pokryć kosztów wysyłki zwrotnej. W tym przypadku będziesz musiał sam pokryć koszty wysyłki!',
  goodNumTip:
    'Uwaga: Jeśli ilość zakupionego produktu jest równa lub większa niż 10 sztuk, w celu zwiększenia efektywności magazynowania inspektorzy jakości przeprowadzą kontrolę jakości tylko dla 20% produktów. Niemniej jednak wszystkie kolory, style i rozmiary produktów zostaną dla Ciebie sprawdzone, dziękujemy za Twoje zrozumienie!',
  'i18n-0000001': 'spersonalizowane wideo',
  'i18n-0000002': 'opis obsługi',
  'i18n-0000003':
    'zostanie nagrany 20-90 sekundowy film produktu (czas trwania może różnić się w zależności od produktu), oferując użytkownikom dostosowaną usługę inspekcji wideo.',
  'i18n-0000004':
    'Uwaga: Aktywacja produktów elektronicznych lub cyfrowych może unieważnić usługę posprzedażną. Platforma nie ponosi odpowiedzialności.',
  'i18n-0000005': `Obecnie jest zbyt mało tras krajowych. Zaleca się, aby przed zakupem produktu przejść na stronę z kalkulacją kosztów transportu lub stronę koszyka, aby obliczyć koszt transportu i uniknąć nadmiernych kosztów logistycznych.`,
  'i18n-0000006': 'Trasy dostaw do kraju docelowego: {lineNum}',
  buyAgain: 'Kup ponownie',
  remindShop: 'Przypomnij o wysyłce',
}
